import { IsArray, IsDefined, IsNumber, IsOptional } from 'class-validator';

export class GetInputClosingRecipeStockDto {
  @IsDefined()
  @IsArray()
  @IsNumber({}, { each: true })
  stockLocationIdList: number[];

  @IsOptional()
  @IsArray()
  @IsNumber({}, { each: true })
  stockCategoryIdList: number[];

  @IsOptional()
  search?: string;
}
